import tools from './tools'
import isValid from './isValid'
import { Message } from 'iview'
import router from '../router'
import vue from "../main";
import errorCode from './errorCode'
import { locale } from 'moment';
import CryptoJS from "crypto-js";
import store from '../store'

//获取token的方法
const getToken = () => {

  if (isValid.isExp()) {
    // let token = tools.getSession('token');
    let token = tools.getLocal('token');
    // console.log('token',token)
    return token;
  } else {
    window.timeOut = 1;
    return false;
  }
}
//获取deleartoken的方法
const getDearlerToken = () => {

  if (isValid.isExp()) {
    // let token = tools.getSession('token');
    let token = tools.getLocal('dealerToken');
    // console.log('token',token)
    return token;
  } else {
    window.timeOut = 1;
    return false;
  }
}

/**
 * ajax  请求后状态处理
 * @param data object 请求后返回的数据   
 * @param off  boolean 参数的状态值    
 * @param fn  function 回调函数    
 * @param fn1  function 失败时回调函数    
 * @param show  boolean 是否弹框    
 */
const ajaxMsg = (data, off, fn, fn1, show) => {
  off = (off === true ? true : false)
  show = (show === false ? false : true)
  //   let hasAuthorization = getToken()
  //   console.log('hasAuthorization',hasAuthorization,isValid.isExp())

  // if(!hasAuthorization ){
  //   Message.error({
  //     content:'Login has expired. Please login again1111'
  //   })
  //   return false
  // }

  let local = sessionStorage.getItem('local') || localStorage.getItem('local') || 'en-US'
  let info = data.message

  // let localLang1 = (navLang === 'zh-CN' || navLang === 'en-US' || navLang === 'en' || navLang === 'zh') ? navLang : false
  // let langObj = {'en':'en-US','en-US':'en-US','zh':'zh-CN','zh-CN':'zh-CN'}
  // let localLang = langObj[localLang1]
  // let local = tools.getLocal1('local') || localLang || 'en-US'

  let langArr = ['en-US', 'en_US', 'en']
  if (langArr.includes(local) && errorCode[data.code]) {
    info = errorCode[data.code]
  }

  if ((data.code != 1 && data.code != 3 && data.code != 11009) && show === true) {

    Message.error({
      content: info || vue.$i18n.t("failed") || 'failed',
      onClose: fn1 ? () => { fn1() } : function () { }
    })
    return false
  }


  if (data.code == 1 && off === true && show === true) {
    Message.success({
      content: data.message || vue.$i18n.t("success") || 'success',
      onClose: fn ? () => { fn() } : function () { }
    })
    return true
  }

  if (data.code == 1 && off === false && show === true) {
    fn ? fn() : () => { }
    return true
  }


  // if(data.code == 3){
  //   window.refreshToken = 2;
  //   sessionStorage.clear();
  //   router.push({name:data.data.url});
  //   return;
  // }


  if (fn && data.code != 11009 && show === false) {
    fn()
  }

}

/**
 * 通用消息框
 * @param type string 消息类型
 * @param content string 消息内容
 * @param fn function 回调
 * 
 */
const msg = (type, content, fn) => {

  // console.log('type',type,info)
  // let hasAuthorization = false

  // if (document.cookie.length > 0) {
  //     var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
  //     for (var i = 0; i < arr.length; i++) {
  //         var arr2 = arr[i].split('='); //再次切割
  //         //判断查找相对应的值
  //         if (arr2[0] == 'Authorization') {
  //           hasAuthorization = true
  //         }
  //     }
  // }

  if (content == 'Error: Request failed with status code 404') {
    return false
  }

  // if(!hasAuthorization && !content.code){
  //   Message.error({
  //     content:'Login has expired. Please login again'
  //   })
  //   return false
  // }

  let info = content

  if (Object.prototype.toString.call(content) == '[object Object]') {
    const navLang = navigator.language

    let localLang1 = (navLang === 'zh-CN' || navLang === 'en-US' || navLang === 'en' || navLang === 'zh') ? navLang : false
    let langObj = { 'en': 'en-US', 'en-US': 'en-US', 'zh': 'zh-CN', 'zh-CN': 'zh-CN' }
    let localLang = langObj[localLang1]
    let local = tools.getLocal1('local') || localLang || 'en-US'


    let langArr = ['en-US', 'en_US', 'en']
    if (langArr.includes(local) && errorCode[content.code]) {
      info = errorCode[content.code]
    } else {
      info = content.message || content.msg || ''
    }

  }




  Message[type]({
    content: info,
    duration: 3,
    onClose: fn ? () => { fn() } : function () { }
  })
}


/**
 * 数组去重
 * @param arr Array 合并后的数组
 */
const unData = (arr) => {
  var map = {};
  if (arr && Array.isArray(arr)) {
    for (var i = arr.length; i >= 0; --i) {
      if (arr[i] in map) {
        arr.splice(arr[i], 1);
      } else {
        map[arr[i]] = true;
      }
    }
  }
  return arr;
}

let transPrice = (price) => {
  if (price == '' || price == 0) {
    return 0
  } else {
    return price = Number((price / 100).toFixed(3))
  }
}

/**
 * ajax  请求后状态处理
 * @param data object 请求后返回的数据   
 * @param off  boolean 参数的状态值    
 * @param fn  function 回调函数    
 * @param fn1  function 失败时回调函数    
 * @param show  boolean 是否弹框    
 */
const ajaxMsg1 = (data, off, fn, fn1, show) => {
  off = (off === true ? true : false)
  show = (show === false ? false : true)

  console.log('data', data)
  let local = sessionStorage.getItem('local') || localStorage.getItem('local')
  let info = data.message

  let langArr = ['en-US', 'en_US', 'en']
  if (langArr.includes(local) && errorCode[data.code]) {
    info = errorCode[data.code]
  }


  if ((data.code != 1 && data.code != 3) && off === true && show === true) {

    Message.error({
      content: info || vue.$i18n.t("failed") || 'failed',
      onClose: fn1 ? () => { fn1() } : function () { }
    })
    return false
  }
}

/**
 * 对象数组排序
 * @param prop string 排序的键名 
 */
const compare = function (prop) {
  return function (obj1, obj2) {
    var val1 = obj1[prop];
    var val2 = obj2[prop];
    if (val1 < val2) {
      return -1;
    } else if (val1 > val2) {
      return 1;
    } else {
      return 0;
    }
  }
}

/**
 * uinfo等数据加密
 * @param data  要加密的数据 
 */
const encryptDataUinfo = function (data, key = 'aes', string = 'uInfo') {

  let newUserInfo = data;
  //加密数据
  let encJson = CryptoJS.AES.encrypt(JSON.stringify(newUserInfo), key).toString();
  //对加密数据进行base64处理, 原理：就是先将字符串转换为utf8字符数组，再转换为base64数据
  let encData = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encJson));
  localStorage.setItem(string, encData);

}
/**
 * uinfo等数据解密
 * @param data  要解密的数据 
 */
const decryptDataUinfo = function (key = 'aes', string = 'uInfo') {
  let decData = CryptoJS.enc.Base64.parse(localStorage.getItem(string)).toString(CryptoJS.enc.Utf8);
  //解密数据
  let decJson = CryptoJS.AES.decrypt(decData, key).toString(CryptoJS.enc.Utf8);
  let userInfo = JSON.parse(decJson);

  return userInfo

}

/**
 * 10进制转16进制 类型0x0f的格式
 *  @param num  要转换的数字
 */
const toHex = function (num) {//将一个数字转化成16进制字符串形式
  return num < 16 ? "0x0" + num.toString(16).toUpperCase() : "0x" + num.toString(16).toUpperCase();
}

/**
 * 深拷贝,递归实现，map用于解决循环引用的问题
 * @param obj  要拷贝的对象
 */

let map = new Map(); // WeakMap
const deepClone = function (obj) {
  let newobj = null;
  if (typeof (obj) == 'object' && obj !== null) {
    if (map.get(obj)) {
      newobj = map.get(obj) // 如果不想循环打印 可以设置为null
    } else {
      newobj = obj instanceof Array ? [] : {};
      map.set(obj, newobj)
      for (var i in obj) {
        newobj[i] = deepClone(obj[i])
      }
    }
  } else {
    newobj = obj
  }
  return newobj;
}

/**
 * 退出登录后清除数据
 */
const removeStorage = (store,router) => {
  let local = localStorage.getItem('local')
  let langSet = localStorage.getItem('langSet')
  let mapType = localStorage.getItem('mapType')
  let centerGeo = localStorage.getItem('centerGeo')
  localStorage.clear();
  sessionStorage.clear();
  store.commit('setTabMenuList', [{ activeId: "0-1", fId: 0, fTitle: "平台首页", name: "平台首页", routeName: "home", routerUrl: "/" }])
  store.commit('setTabMenuItem', { activeId: "0-1", fId: 0, fTitle: "平台首页", name: "平台首页", routeName: "home", routerUrl: "/" })
  document.cookie = "Authorization=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  localStorage.setItem('local', local)
  localStorage.setItem('langSet', langSet)
  localStorage.setItem('mapType', mapType)
  localStorage.setItem('centerGeo', centerGeo)
  router.push({ name: 'login', params: {} })
}

/**
 * 防抖
 */

const antiShake = function (fn, delay=500) {
  let timer = null;
  return function () {
    let content = this;
    let args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(content, args);
    }, delay);
  };
};

// 

const buffer_uint8 = function (value) {
  var uint8Array = new Uint8Array(1);
  var dv = new DataView(uint8Array.buffer, 0);
  dv.setUint8(0, value);
  return [].slice.call(uint8Array);
}

const  buffer_int8 = function (value) {
  var uint8Array = new Uint8Array(1);
  var dv = new DataView(uint8Array.buffer, 0);
  dv.setInt8(0, value);
  return [].slice.call(uint8Array);
}

const buffer_uint16 = function (value) {
  var uint8Array = new Uint8Array(2);
  var dv = new DataView(uint8Array.buffer, 0);
  dv.setUint16(0, value);
  return [].slice.call(uint8Array);
}

const buffer_int16 = function (value) {
  var uint8Array = new Uint8Array(2);
  var dv = new DataView(uint8Array.buffer, 0);
  dv.setInt16(0, value);
  return [].slice.call(uint8Array);
}

const buffer_uint32 = function (value) {
  var uint8Array = new Uint8Array(4);
  var dv = new DataView(uint8Array.buffer, 0);
  dv.setUint32(0, value);
  return [].slice.call(uint8Array);
}

const buffer_int32 = function (value) {
  var uint8Array = new Uint8Array(4);
  var dv = new DataView(uint8Array.buffer, 0);
  dv.setInt32(0, value);
  return [].slice.call(uint8Array);
}

const buffer_double64 = function (value) {
  var uint8Array = new Uint8Array(8);
  var dv = new DataView(uint8Array.buffer, 0);
  dv.setFloat64(0, value);
  return [].slice.call(uint8Array);
}

const buffer_float = function (value) {
  var uint8Array = new Uint8Array(8);
  var dv = new DataView(uint8Array.buffer, 0);
  dv.setFloat32(0, value);
  return [].slice.call(uint8Array);
}

const buffer_string = function (value) {//字符串转换为Uint8Array
  var length = value.length;
  var uint8Array = new Uint8Array(length + 2)
  uint8Array[0] = Math.floor(length / 256);
  uint8Array[1] = length % 256;
  for (var i = 0; i < length; i++) {
      uint8Array[i + 2] = value.charCodeAt(i);
  }
  return [].slice.call(uint8Array);
}
const  buffer_string1 = function (value) {//字符串转换为Uint8Array
  var length = value.length;
  let arr = []
  for (var i = 0; i < length; i=i+2) {
      let intval =parseInt(value.slice(i,i+2),16) 
      arr.push(intval&0xff) ;
  }
   return arr
  
}

const buffer_uint8array = function (value) {
  return [].slice.call(value);
}

const hexStringToBytes = function (hex) {
  if (hex.startsWith("0x")) {
      hex = hex.substring(2)
  }
  if (hex.length % 2 !== 0) {
      hex = "0" + hex
  }
  var bytes = new Uint8Array(Math.ceil(hex.length / 2));
  for (var i = 0; i < bytes.length; i++) bytes[i] = parseInt(hex.substr(i * 2, 2), 16);
  return bytes;
}

const Bytes2Str = function (arrBytes) {
  var str = "";
  for (var i = 0; i < arrBytes.length; i++) {
      var tmp;
      var num = arrBytes[i];
      if (num < 0) {
          //此处填坑，当byte因为符合位导致数值为负时候，需要对数据进行处理
          tmp = (255 + num + 1).toString(16);
      } else {
          tmp = num.toString(16);
      }
      if (tmp.length == 1) {
          tmp = "0" + tmp;
      }
      if (i > 0) {
          str += ":" + tmp;
      } else {
          str += tmp;
      }
  }
  return str;
}

const decodeString = function (dataView, index, length) {
  var strArr = []; // new Uint8Array(length);
  for (var i = 0; i < length; i++) {
      strArr[i] = dataView.getInt8(i + index);
  }
  var str = String.fromCharCode.apply(String, strArr);
  return str;
}
const decodeString1 = function (dataView, index, length) {
  var str = ''; // new Uint8Array(length);
  var strArr = []
  for (var i = 0; i < length; i++) {
      strArr[i] = dataView.getUint8(i + index).toString(16);
      if(strArr[i].length==1){
          strArr[i] = '0'+strArr[i]
      }
  }
  str = strArr.join('')
  return str

}

const decodeUint32Array = function (dataView, index, length) {
  var result = [];
  for (var i = 0; i < length; i += 4) {
      result = result.concat(dataView.getUint32(index + i));
  }
  return result;
}

const decodeUint8Array = function (dataView, index, length) {
  var result = [];
  for (var i = 0; i < length; i++) {
      result = result.concat(dataView.getUint8(index + i));
  }
  return result;
}

const base64ToArrayBuffer = function (base64) {
  var binary_uint8 = base64Decode(base64);
  var len = binary_uint8.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
      bytes[i] = binary_uint8[i];
  }
  return bytes.buffer;
}
//10进制转16进制补0,不带0x
const dec2hex = function (dec, len) {
  var hex = "";
  while (dec) {
      var last = dec & 15;
      hex = String.fromCharCode(((last > 9) ? 55 : 48) + last) + hex;
      dec >>= 4;
  }
  if (len) {
      while (hex.length < len) hex = '0' + hex;
  }
  return hex;
}

const string_hex2int = function (hex) {// 16进制的字符串 转换为整数
  var len = hex.length, a = new Array(len), code;
  for (var i = 0; i < len; i++) {
      code = hex.charCodeAt(i);
      if (48 <= code && code < 58) {
          code -= 48;
      } else {
          code = (code & 0xdf) - 65 + 10;
      }
      a[i] = code;
  }

  return a.reduce(function (acc, c) {
      acc = 16 * acc + c;
      return acc;
  }, 0);
}

// 16进制转二进制
const string_hex2two = function (hexStr,len=0){


   // 使用 BigInt 解析 16 进制字符串
   const bigIntValue = BigInt("0x" + hexStr);
  
   // 将 BigInt 转换为二进制字符串
   let binaryStr = bigIntValue.toString(2);

   if(len>0){

     // 补充前导零，确保二进制字符串的长度为指定的 length
     binaryStr = binaryStr.padStart(len, '0');
   }else{
    // 计算需要补零的位数
    const remainder = binaryStr.length % 8;

    if (remainder !== 0) {
        // 补零到满足 8 的倍数
        binaryStr = binaryStr.padStart(binaryStr.length + (8 - remainder), '0');
    }

  }
   
   
   // 返回最终的二进制字符串
   return binaryStr;



}

// 10进制转二进制
const string_ten2two = function (c_Value,len=0) { //根据Value中的十进制数，返回一个存有二进制每一位的字符串
  var binaryString = parseInt(c_Value).toString(2);
   // 如果指定了长度，补零到指定长度
   if (len >0) {
       binaryString = binaryString.padStart(len, '0');
   } else {
       // 否则补零到 8 的倍数
       const remainder = binaryString.length % 8;
       if (remainder !== 0) {
           binaryString = binaryString.padStart(binaryString.length + (8 - remainder), '0');
       }
   }
   
   return binaryString;

}

const ChangeHourMinutestr = function (str,flag='hour') {//小时或分钟转小时加分钟

  if(flag=='hour'){

      if (str !== "0" && str !== "" && str !== null) {
        let hours = str.split('.')[0] || 0
        let minutes = str.split('.')[1] || 0
        return (hours.toString().length<2?'0'+hours.toString():hours.toString())+":"+((minutes*6).toString().length<2?'0'+(minutes*6).toString():(minutes*6).toString())
      }else{
          return "";
      }
  }

  if(flag=='minute'){
      if (str !== "0" && str !== "" && str !== null) {
          return ((Math.floor(str / 60)).toString().length < 2 ? "0" + (Math.floor(str / 60)).toString() :  (Math.floor(str / 60)).toString()) + ":" + ((str % 60).toString().length < 2 ? "0" + (str % 60).toString() : (str % 60).toString());
      }else{
          return "";
      }
  }


}

const ChangeHour = function (str,flag='hour') {//小时或分钟转小时加分钟

  if(flag=='hour'){
  
      if (str !== "0" && str !== "" && str !== null) {
        let hours = str.split('.')[0] || 0
        let minutes = 0
        return (hours.toString().length<2?'0'+hours.toString():hours.toString())+":"+((minutes*60).toString().length<2?'0'+(minutes*60).toString():(minutes*60).toString())
      }else{
          return "";
      }
  }
}

const ChangeSeconds = function (seconds,flag='HH:mm:ss'){// 秒转其他显示格式
// 'HH-MM-SS':'HH:mm:ss','HH-MM':'HH:mm','MM-SS':'mm:ss','MM-SS-MS':'mm:ss.SSS','SS-MS':'ss.SSS'

   if(flag=='HH:mm:ss'){
       // 计算小时、分钟和秒
       const hours = Math.floor(seconds / 3600);
       const minutes = Math.floor((seconds % 3600) / 60);
       const secs = seconds % 60;
   
       // 将小时、分钟和秒格式化为两位数
       const pad = (num) => num.toString().padStart(2, '0');
       // 返回时分秒格式
       return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
   }

   if(flag=='HH:mm'){
     // 计算小时、分钟和秒
     const hours = Math.floor(seconds / 3600);
     const minutes = Math.floor((seconds % 3600) / 60);
     const secs = seconds % 60;
 
     // 将小时、分钟和秒格式化为两位数
     const pad = (num) => num.toString().padStart(2, '0');
 
     // 返回时分秒格式
     return `${pad(hours)}:${pad(minutes)}`;
   }

   if(flag=='mm:ss'){
     // 计算分钟和秒
     const minutes = Math.floor(seconds / 60);
     const secs = Math.floor(seconds % 60);
 
     // 将分钟和秒格式化为两位数
     const pad = (num) => num.toString().padStart(2, '0');
 
     // 返回分秒格式
     return `${pad(minutes)}:${pad(secs)}`;
   }

   if(flag=='mm:ss.SSS'){
     // 计算分钟、秒和毫秒
    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    const ms = Math.floor((seconds - Math.floor(seconds)) * 1000);

    // 将分钟、秒和毫秒格式化为固定位数
    const pad = (num, length = 2) => num.toString().padStart(length, '0');

    // 返回分秒毫秒格式
    return `${pad(minutes)}:${pad(secs)}.${pad(ms, 3)}`;
   }


   if(flag=='ss.SSS'){
     // 获取整数秒部分
     const secs = Math.floor(seconds);

     // 获取毫秒部分
     const ms = Math.floor((seconds - secs) * 1000);
 
     // 将秒和毫秒格式化为固定位数
     const pad = (num, length = 2) => num.toString().padStart(length, '0');
 
     // 返回秒毫秒格式
     return `${pad(secs)}.${pad(ms, 3)}`;
   }


}
 //在buff中定位出第idx个klv
  //返回：在buff中的klv偏移
const sub_getKlvByIdx = function (bytes, idx) {
    var offset = 2; //head 2 byte
    var valueLen;
    for (var i = 0; i < idx; i++) {
        valueLen = (bytes[offset + 1] & 0x3F); //klv中len的计算
        offset += 2 + valueLen;
    }
    if (offset >= bytes.length) //已经取完
    {
        return -1;
    }
    return offset;
}

// 判断是不是数值型字符串
const isNumberStr = function (str){
  return !isNaN(parseFloat(str))&& isFinite(str)
}

//2进制转10进制 bit 最高位是1为负数，0是正数
const string_two2tenSymbol = function (str){
  
  let flag = str.slice(0,1)

  let twoV = flag==1?str.replace(/^1/, '0'):str

  let decV = flag==1 ? parseInt(twoV,2)*(-1):parseInt(twoV,2)
  return decV
}





export default {
  ChangeHour,
  ChangeHourMinutestr,
  string_ten2two,
  string_hex2int,
  dec2hex,
  base64ToArrayBuffer,
  decodeUint8Array,
  decodeUint32Array,
  decodeString1,
  decodeString,
  Bytes2Str,
  hexStringToBytes,
  buffer_uint8array,
  buffer_string1,
  buffer_string,
  buffer_float,
  buffer_uint8,
  buffer_int8,
  buffer_uint16,
  buffer_int16,
  buffer_uint32,
  buffer_int32,
  buffer_double64,
  sub_getKlvByIdx,
  string_hex2two,
  isNumberStr,
  string_two2tenSymbol,
  ChangeSeconds,

  getToken,
  getDearlerToken,
  ajaxMsg,
  msg,
  antiShake,
  unData,
  transPrice,
  ajaxMsg1,
  compare,
  encryptDataUinfo,
  decryptDataUinfo,
  toHex,
  deepClone,
  removeStorage
}
